export const theme = {
  theme_indigo: "#3949AB",
  theme_orange: "#f37a17",
  theme_green: "#388E3C",
  theme_gray: "#37474F",
  theme_yellow: "#FFC107",
  theme_blue: "#0288D1",
  theme_cyan: "#00838F",
  theme_teal: "#00796B",
  theme_red: "#D32F2F",
  primary: "#f37a17",
  secondary: "#c8c9ce",
  accent: "#e7e7e7",
  error: "#FF5252",
  info: "#2196F3",
  success: "#4CAF50",
  warning: "#FFC107"
};
